import { createRouter, createWebHistory, RouterView } from "vue-router";
import { captureSalesCode } from "@/utils/referral";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const Home = () => import("@/views/Home");
const Index = () => import("@/views/Index");
const About = () => import("@/views/About");
const HowItWork = () => import("@/views/HowItWork");
const FormVideo = () => import("@/views/FormVideo");
const ContactUs = () => import("@/views/ContactUs");
// Views

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

//App
const RegisterApp = () => import("@/views/RegisterApp");
const RegisterHomepage = () => import("@/views/RegisterHomepage");
const WhoAreYou = () => import("@/views/WhoAreYou");
const LoginNew = () => import("@/views/Login");
const InterviewerrVideo = () => import("@/views/InterviewerrVideo");
const Result = () => import("@/views/Result");
const Faq = () => import("@/views/FAQ");
const LoginAccount = () => import("@/views/LoginAccount");
const outh = () => import("@/views/outh");
const Blog = () => import("@/views/Blog");
const Legal = () => import("@/views/Legal");
const DashboardParticipant = () => import("@/views/DashboardParticipant");
const Profile = () => import("@/views/Profile");
const interest = () => import("@/views/SignUp");
const PlanIndividual = () => import("@/views/PlanIndividual");
const PlanCompany = () => import("@/views/PlanCompany");
const ListCandidate = () => import("@/views/ListCandidate");

const SubscribeCandidate = () => import('@/views/SubscribeCandidate')
const Recruitement = () => import('@/views/Recruitment')
const Dashboard = () => import('@/views/Dashboard')
const Setting = () => import('@/views/Setting')
const JoinUs = () => import('@/views/JoinUs')
const ForgotPassword = () => import('@/views/ForgotPassword')
const TestVideo = () => import('@/views/TestVideo')
const TestSetting = () => import('@/views/TestSetting')
const VerifyPassword = () => import('@/views/VerifyPassword')
const ResetPassword = () => import('@/views/ResetPassword')
const EditProfile = () => import('@/views/EditProfile')
const Receipt = () => import('@/views/Receipt')
const VerifyEmail = () => import('@/views/VerifyEmail')
const ConfirmationPackage = () => import('@/views/ConfirmationPackage')
const Payment = () => import('@/views/Payment')
const ManageVoucher = () => import('@/views/ManageVoucher')
const ManageBlog = () => import('@/views/ManageBlog')
const UploadBlogArticle = () => import('@/views/UploadBlogArticle')
const BlogAuthorLogin = () => import('@/views/BlogAuthorLogin')
const ManageCountries = () => import('@/views/ManageFlag')
const ManageContactUs = () => import('@/views/ManageContact')
const ManageUser = () => import('@/views/ManageUser')
const ManageSubscription = () => import('@/views/ManageSubscription')
const ManageQuizPassword = () => import('@/views/ManageQuizPassword')
const ManageQuizPurchase = () => import('@/views/ManageQuizPurchase')
const SalesReport = () => import('@/views/SalesReport')
const QuizResults = () => import('@/views/QuizResults')
const QuestionFeedbackAdmin = () => import('@/views/QuestionFeedbackAdmin')
const PromoPostersAdmin = () => import('@/views/PromoPostersAdmin')
const FloatingPostersAdmin = () => import('@/views/FloatingPostersAdmin')
const NewsAdmin = () => import('@/views/NewsAdmin')
const ManageArtikulasi = () => import('@/views/ManageArtikulasi')
const ManageUsers = () => import('@/views/ManageUsers')
const AdminHub = () => import('@/views/AdminHub')
const GenerateReport = () => import('@/views/GenerateReport')
const InterviewCandidateList = () => import('@/views/InterviewCandidateList')
const ShortlistedCandidate = () => import('@/views/ShortlistedCandidate')
const SuccessReceipt = () => import('@/views/SuccessReceipt')
const CancelPayment = () => import('@/views/CancelPayment')
const ReviewResume = () => import('@/views/ReviewResume')
const PortalJob = () => import('@/views/PortalJob')
const VideoList = () => import('@/views/VideoList')
const HomepageUser = () => import('@/views/Homepage')
const ManageApplicant = () => import('@/views/ManageApplicant')
const QR = () => import('@/views/QR')
const DirectInterview = () => import('@/views/DirectInterview')
const ManageQR = () => import('@/views/ManageQR')
const ManageQRJob = () => import('@/views/ManageQRJob')
const AskAI = () => import('@/views/AskAI')
const AnswerAI = () => import('@/views/AnswerAI')
const JobSeeker = () => import('@/views/JobSeeker')
// const VideoPlaylist = () => import('@/views/VideoPlaylist')
const Policy = () => import('@/views/Policy')
const CreativeInsight = () => import('@/views/CreativeInsight')
const ResultAI = () => import('@/views/ResultAI')
const CounterVisitor = () => import('@/views/CounterVisitor')
const ManageAccess = () => import('@/views/ManageAccess')
const ReportAI = () => import('@/views/ReportAI')
const AdminChat = () => import('@/views/AdminChat')
const HowItWorkCompany = () => import('@/views/HowItWorkCompany')
const HowItWorkCandidate = () => import('@/views/HowItWorkCandidate')
const TestChat = () => import('@/views/TestChat')
const ManageFeature = () => import('@/views/ManageFeature')
const ResumeCandidate = () => import('@/views/ResumeCandidate')
const ManageVoucherCompany = () => import('@/views/ManageVoucherCompany')
const OurProduct = () => import('@/views/OurProduct')
const Cart = () => import('@/views/Cart')
const DetailProduct = () => import('@/views/DetailProduct')
const Teachers = () => import('@/views/Teachers')
const SelectionTypeUser = () => import('@/views/SelectionTypeUser')
const SignUpParent = () => import('@/views/SignUpParent')
const LearningPort = () => import('@/views/LearningPort')
const Package = () => import('@/views/Package')
const ShoppingCart = () => import('@/views/ShoppingCart')
const StudentAchievement = () => import('@/views/StudentAchievement')
const ShoppingCart_test = () => import('@/views/ShoppingCart_test')
const PaymentFailed = () => import('@/views/PaymentFailed')
const PaymentSuccess = () => import('@/views/PaymentSuccess')
const SuccessSubscribe = () => import('@/views/SuccessSubscribe')
// Halaman affiliate lama (views/Affiliate.vue + views/RegisterAffiliate.vue) tidak lagi
// digunakan — kedua-dua route kini redirect ke halaman TAP. Fail dibiarkan di repo.
const TapProgram = () => import('@/views/TapProgram')
const TapDashboard = () => import('@/views/TapDashboard')
const TapAdmin = () => import('@/views/TapAdmin')
const Quiz = () => import('@/views/quiz/myfirst/Quiz')
const QuizHub = () => import('@/views/QuizHub')
const QuizPKSKSet2 = () => import('@/views/QuizPKSKSet2')
const QuizPlay = () => import('@/views/QuizPlay')
const QuizTry = () => import('@/views/QuizTry')
const QuizAuth = () => import('@/views/QuizAuth')
const QuizSubscription = () => import('@/views/QuizSubscription')
const GamesHub = () => import('@/views/GamesHub')
const GamesHubRoblox = () => import('@/views/GamesHubRoblox')
const GamesHubMental = () => import('@/views/GamesHubMental')
const ManageGamesVip = () => import('@/views/ManageGamesVip')
const WordSearch = () => import('@/views/WordSearch')
const WordScramble = () => import('@/views/WordScramble')
const Sudoku = () => import('@/views/Sudoku')

const router = createRouter({
  history: createWebHistory("/"),
  linkActiveClass: "active",
  scrollBehavior: () => ({ top: 0 }),
  routes: configRoutes(),
});

router.beforeEach((to, from, next) => {
  // Alias URL polisi refund (cth. /Policy-refund.html atau /policy-refund.html)
  // → halaman statik sebenar /polisi-refund.html (fail statik, bukan route Vue).
  const p = (to.path || "").toLowerCase().replace(/\/+$/, "");
  if (p === "/policy-refund.html" || p === "/policy-refund" || p === "/polisi-refund") {
    window.location.replace("/polisi-refund.html");
    return;
  }
  if (to.meta.requiresAuth && !localStorage.getItem('authToken')) {
    next({ name: 'QuizAuth', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

// Capture salesperson ?ref= / ?sales= from ANY page (incl. homepage) on every
// navigation so the tracking code follows the user across the whole site and
// the newest code overwrites the previous one.
router.afterEach(() => {
  captureSalesCode();
});

export default router;

function configRoutes() {
  return [
      {
        path: '/',
        name: 'Root',
        component: Index,
      },
      {
        path: '/BlogAuthorLogin',
        name: 'BlogAuthorLogin',
        component: BlogAuthorLogin,
      },
      {
        path: '/UploadBlogArticle',
        name: 'UploadBlogArticleStandalone',
        component: UploadBlogArticle,
      },
      {
        path: '/quiz-admin',
        name: 'QuizAdmin',
        component: ManageQuizPassword,
      },
      {
        path: '/quiz-purchase-admin',
        name: 'QuizPurchaseAdmin',
        component: ManageQuizPurchase,
      },
      {
        path: '/sales-report-admin',
        name: 'SalesReportAdmin',
        component: SalesReport,
      },
      {
        path: '/quiz-results-admin',
        name: 'QuizResultsAdmin',
        component: QuizResults,
      },
      {
        path: '/feedback-admin',
        name: 'QuestionFeedbackAdmin',
        component: QuestionFeedbackAdmin,
      },
      {
        path: '/posters-admin',
        name: 'PromoPostersAdmin',
        component: PromoPostersAdmin,
      },
      {
        path: '/floating-posters-admin',
        name: 'FloatingPostersAdmin',
        component: FloatingPostersAdmin,
      },
      {
        path: '/news-admin',
        name: 'NewsAdmin',
        component: NewsAdmin,
      },
      {
        path: '/games-vip-admin',
        name: 'GamesVipAdmin',
        component: ManageGamesVip,
      },
      {
        path: '/artikulasi-admin',
        name: 'ArtikulasiAdmin',
        component: ManageArtikulasi,
      },
      {
        path: '/manage-users',
        name: 'ManageUsers',
        component: ManageUsers,
      },
      {
        path: '/admin',
        name: 'AdminHub',
        component: AdminHub,
      },
      {
        path: '/',
        component: TheContainer,
      children: [
        {
          path: "SubscribeCandidate",
          name: "SubscribeCandidate",
          component: SubscribeCandidate,
        },
        {
          path: "Recruitment",
          name: "Recruitement",
          component: Recruitement,
        },
        {
          path: 'Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'Payment',
          name: 'Payment',
          component: Payment
        },
        {
          path: 'ManageVoucher',
          name: 'ManageVoucher',
          component: ManageVoucher
        },
        {
          path: 'ManageBlog',
          name: 'ManageBlog',
          component: ManageBlog
        },
        {
          path: 'ManageContact',
          name: 'ManageContact',
          component: ManageContactUs
        },
        {
          path: 'ManageUser',
          name: 'ManageUser',
          component: ManageUser
        },
        {
          path: 'ManageSubscription',
          name: 'ManageSubscription',
          component: ManageSubscription
        },
        {
          path: 'ManageQuizPassword',
          name: 'ManageQuizPassword',
          component: ManageQuizPassword
        },
        {
          path: 'ManageArtikulasi',
          name: 'ManageArtikulasi',
          component: ManageArtikulasi
        },
        {
          path: 'ManageApplicant',
          name: 'ManageApplicant',
          component: ManageApplicant
        },
        {
          path: 'ManageFlag',
          name: 'ManageCountries',
          component: ManageCountries
        },
        {
          path: 'ManageVoucherCompany',
          name: 'ManageVoucherCompany',
          component: ManageVoucherCompany
        },
        {
          path: 'GenerateReport',
          name: 'GenerateReport',
          component: GenerateReport
        },
        {
          path: 'InterviewCandidateList',
          name: 'InterviewCandidateList',
          component: InterviewCandidateList
        },
        {
          path: 'ShortlistedCandidate',
          name: 'ShortlistedCandidate',
          component: ShortlistedCandidate
        },
        {
          path: 'VideoList',
          name: 'VideoList',
          component: VideoList
        },
        {
          path: 'ManageAccess',
          name: 'ManageAccess',
          component: ManageAccess
        },
        {
          path: 'ManageQR',
          name: 'ManageQR',
          component: ManageQR
        },
        {
          path: 'ManageQRJob',
          name: 'ManageQRJob',
          component: ManageQRJob
        },
        {
          path: 'AskAI',
          name: 'AskAI',
          component: AskAI
        },
        {
          path: 'AnswerAI',
          name: 'AnswerAI',
          component: AnswerAI
        },
        {
          path: 'JobSeeker',
          name: 'JobSeeker',
          component: JobSeeker
        },
        {
          path: 'CounterVisitor',
          name: 'CounterVisitor',
          component: CounterVisitor
        },
        {
          path: 'HowItWorkCompany',
          name: 'HowItWorkCompany',
          component: HowItWorkCompany
        },
        {
          path: 'ManageFeature',
          name: 'ManageFeature',
          component: ManageFeature
        },
       
        {
          path: "theme",
          redirect: "/theme/colors",
          
          component: RouterView,
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },

        {
          path: "base",
          redirect: "/base/cards",
          
          component: RouterView,
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          
          component: RouterView,
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          
          component: RouterView,
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          
          component: RouterView,
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      
      component: RouterView,
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "LoginCUI",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },

    {
      path: "/",
      redirect: "/home",
      
      component: RouterView,
      children: [
        {
          path: "home",
          name: "home",
          component: Home,
        },
      ],
    },

    {
      path: "/",
      redirect: "/Index",
      
      component: RouterView,
      children: [
        {
          path: "Index",
          name: "Index",
          component: Index,
          meta: {
            title: "FlyHigh Education Centre | Tuisyen Online SPM, UPKK, UASA & PKSK Malaysia",
            description: "Platform tuisyen online terbaik Malaysia untuk pelajar SPM, UPKK Tahun 5, UASA Form 3 dan PKSK (SBP & MRSM). Guru berpengalaman, jadual fleksibel.",
            canonical: "https://www.flyhigh.my/Index",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "About",
          name: "About",
          component: About,
          meta: {
            title: "Tentang Kami | FlyHigh Education Centre",
            description: "Kenali FlyHigh Education Centre — misi kami, pasukan guru berpengalaman, dan komitmen kami untuk membantu pelajar Malaysia mencapai kecemerlangan akademik.",
            canonical: "https://www.flyhigh.my/About",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "HowItWork",
          name: "HowItWork",
          component: HowItWork,
          meta: {
            title: "Cara Kerja FlyHigh | Bagaimana Platform Tuisyen Online Kami Berfungsi",
            description: "Pelajari cara platform tuisyen online FlyHigh berfungsi — dari pendaftaran, pilih pakej, akses kelas live dan modul rakaman, hingga peperiksaan latihan.",
            canonical: "https://www.flyhigh.my/HowItWork",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "FormVideo",
          name: "FormVideo",
          component: FormVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ContactUs",
          name: "ContactUs",
          component: ContactUs,
          meta: {
            title: "Hubungi Kami | FlyHigh Education Centre",
            description: "Ada soalan tentang program FlyHigh? Hubungi kami melalui WhatsApp, emel atau borang pertanyaan. Pasukan kami sedia membantu anda.",
            canonical: "https://www.flyhigh.my/ContactUs",
          },
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "RegisterApp",
          name: "RegisterApp",
          component: RegisterApp,
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "RegisterHomepage",
          name: "RegisterHomepage",
          component: RegisterHomepage,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "WhoAreYou",
          name: "WhoAreYou",
          component: WhoAreYou,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Login",
          name: "Login",
          component: LoginNew,
          meta: {
            title: "Log Masuk | FlyHigh Education Centre",
            description: "Log masuk ke akaun FlyHigh anda untuk akses kelas online, modul belajar dan jadual tuisyen.",
            canonical: "https://www.flyhigh.my/Login",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "InterviewerrVideo",
          name: "InterviewerrVideo",
          component: InterviewerrVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Result",
          name: "Result",
          component: Result,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Faq",
          name: "Faq",
          component: Faq,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "LoginAccount",
          name: "LoginAccount",
          component: LoginAccount,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "outh",
          name: "outh",
          component: outh,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Blog",
          name: "Blog",
          component: Blog,
          meta: {
            title: "Blog Pendidikan Malaysia | Tips SPM, UPKK & UASA — FlyHigh",
            description: "Artikel pendidikan terkini tentang SPM, UPKK, UASA, MRSM, SBP dan strategi belajar. Panduan lengkap untuk pelajar dan ibu bapa Malaysia.",
            canonical: "https://www.flyhigh.my/Blog",
          },
        },
      ],
    },

    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Legal",
          name: "Legal",
          component: Legal,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "DashboardParticipant",
          name: "DashboardParticipant",
          component: DashboardParticipant,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Profile",
          name: "Profile",
          component: Profile,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "signup",
          name: "interest",
          component: interest,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "PlanIndividual",
          name: "PlanIndividual",
          component: PlanIndividual,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "PlanCompany",
          name: "PlanCompany",
          component: PlanCompany,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ListCandidate",
          name: "ListCandidate",
          component: ListCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "JoinUs",
          name: "JoinUs",
          component: JoinUs,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ForgotPassword",
          name: "ForgotPassword",
          component: ForgotPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "VerifyPassword",
          name: "VerifyPassword",
          component: VerifyPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "TestVideo",
          name: "TestVideo",
          component: TestVideo,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "TestSetting",
          name: "TestSetting",
          component: TestSetting,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ResetPassword",
          name: "ResetPassword",
          component: ResetPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "EditProfile",
          name: "EditProfile",
          component: EditProfile,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Receipt",
          name: "Receipt",
          component: Receipt,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "SuccessReceipt",
          name: "SuccessReceipt",
          component: SuccessReceipt,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "CancelPayment",
          name: "CancelPayment",
          component: CancelPayment,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "VerifyEmail",
          name: "VerifyEmail",
          component: VerifyEmail,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ConfirmationPackage",
          name: "ConfirmationPackage",
          component: ConfirmationPackage,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ReviewResume",
          name: "ReviewResume",
          component: ReviewResume,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "PortalJob",
          name: "PortalJob",
          component: PortalJob,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Homepage",
          name: "Homepage",
          component: HomepageUser,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "QR",
          name: "QR",
          component: QR,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "DirectInterview",
          name: "DirectInterview",
          component: DirectInterview,
        },
      ],
    },
    // {
    //   path: "/",
    //   redirect: "/",
    //   name: "VideoPlaylist",
    //   component: {
    //     render(c) {
    //       return c("router-view");
    //     },
    //   },
    //   children: [
    //     {
    //       path: "VideoPlaylist",
    //       name: "VideoPlaylist",
    //       component: VideoPlaylist,
    //     },
    //   ],
    // },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Policy",
          name: "Policy",
          component: Policy,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "CreativeInsight",
          name: "CreativeInsight",
          component: CreativeInsight,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ResultAI",
          name: "ResultAI",
          component: ResultAI,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ReportAI",
          name: "ReportAI",
          component: ReportAI,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "AdminChat",
          name: "AdminChat",
          component: AdminChat,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "HowItWorkCandidate",
          name: "HowItWorkCandidate",
          component: HowItWorkCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "TestChat",
          name: "TestChat",
          component: TestChat,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ResumeCandidate",
          name: "ResumeCandidate",
          component: ResumeCandidate,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "OurProduct",
          name: "OurProduct",
          component: OurProduct,
          meta: {
            title: "Pakej & Produk Tuisyen | FlyHigh Education Centre",
            description: "Lihat semua pakej tuisyen online FlyHigh — Solo Course, Combo Course dan LearningPort untuk pelajar SPM, UPKK dan UASA. Harga berpatutan, kualiti terbaik.",
            canonical: "https://www.flyhigh.my/OurProduct",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Cart",
          name: "Cart",
          component: Cart,
        },
      ],
    },
    {
          path: '/DetailProduct/:id',
          name: "DetailProduct",
          component: DetailProduct,
      
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Teachers",
          name: "Teachers",
          component: Teachers,
          meta: {
            title: "Guru & Tutor FlyHigh | Tenaga Pengajar Berpengalaman Malaysia",
            description: "Kenali guru-guru hebat FlyHigh — pakar mata pelajaran SPM, UPKK dan UASA dengan pengalaman bertahun-tahun membantu pelajar cemerlang.",
            canonical: "https://www.flyhigh.my/Teachers",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "SelectionTypeUser",
          name: "SelectionTypeUser",
          component: SelectionTypeUser,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "SignUpParent",
          name: "SignUpParent",
          component: SignUpParent,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "LearningPort",
          name: "LearningPort",
          component: LearningPort,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "Package",
          name: "Package",
          component: Package,
          meta: {
            title: "Pakej Tuisyen FlyHigh | Pilih Pakej Terbaik untuk Anak Anda",
            description: "Bandingkan pakej tuisyen FlyHigh — harga, subjek, dan faedah setiap pakej. Pilih yang paling sesuai untuk pelajar SPM, UPKK atau UASA.",
            canonical: "https://www.flyhigh.my/Package",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ShoppingCart",
          name: "ShoppingCart",
          component: ShoppingCart,
        },
      ],
    },
     {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "StudentAchievement",
          name: "StudentAchievement",
          component: StudentAchievement,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "ShoppingCart_test",
          name: "ShoppingCart_test",
          component: ShoppingCart_test,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "PaymentFailed",
          name: "PaymentFailed",
          component: PaymentFailed,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "PaymentSuccess",
          name: "PaymentSuccess",
          component: PaymentSuccess,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          path: "SuccessSubscribe",
          name: "SuccessSubscribe",
          component: SuccessSubscribe,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      
      component: RouterView,
      children: [
        {
          // Halaman affiliate lama (rosak) — semua trafik dialihkan ke TAP.
          path: "Affiliate",
          name: "Affiliate",
          redirect: "/tap/dashboard",
        },
      ],
    },
    {
      path: "/",
      redirect: "/",

      component: RouterView,
      children: [
        {
          // Halaman pendaftaran affiliate lama — dialihkan ke pendaftaran guru TAP.
          path: "RegisterAffiliate",
          name: "RegisterAffiliate",
          redirect: "/tap",
        },
      ],
    },
    {
      path: "/",
      redirect: "/",

      component: RouterView,
      children: [
        {
          path: "tap",
          name: "TapProgram",
          component: TapProgram,
          meta: {
            title: "Teacher Affiliate Program (TAP) | FlyHigh Education Centre",
            description: "Sertai FlyHigh Teacher Affiliate Program (TAP) — kongsi produk pembelajaran FlyHigh dan jana pendapatan tambahan. Pendaftaran percuma untuk guru.",
            canonical: "https://www.flyhigh.my/tap",
          },
        },
        {
          path: "tap/dashboard",
          name: "TapDashboard",
          component: TapDashboard,
          meta: {
            title: "Dashboard Guru TAP | FlyHigh Education Centre",
            description: "Pantau jualan, komisen dan status pembayaran anda sebagai guru affiliate FlyHigh.",
          },
        },
        {
          path: "tap-admin",
          name: "TapAdmin",
          component: TapAdmin,
          meta: {
            title: "Pentadbir TAP | FlyHigh Education Centre",
            description: "Urus pendaftaran guru, kadar komisen dan pembayaran komisen Teacher Affiliate Program.",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/",

      component: RouterView,
      children: [
        {
          path: "QuizFlyHigh",
          name: "Quiz",
          component: Quiz,
          meta: {
            title: "Quiz Percuma | Uji Pengetahuan Anda — FlyHigh",
            description: "Cuba quiz percuma FlyHigh! 10 soalan menarik untuk menguji pengetahuan anda. Dapatkan sijil dan keputusan terperinci.",
            canonical: "https://www.flyhigh.my/QuizFlyHigh",
          },
        },
        {
          path: "quizhub",
          name: "QuizHub",
          component: QuizHub,
          meta: {
            title: "FlyHigh Quiz — Uji Minda, Capai Bintang! | FlyHigh Education Centre",
            description: "Platform quiz interaktif FlyHigh Education Centre. Uji pengetahuan UPKK, PKSK, UASA, SPM dan banyak lagi!",
            canonical: "https://www.flyhigh.my/quizhub",
          },
        },
        {
          path: "gameshub",
          name: "GamesHub",
          component: GamesHub,
          meta: {
            title: "Games Hub — Bermain Sambil Belajar | FlyHigh Education Centre",
            description: "Games Hub FlyHigh: koleksi Roblox Games & Mental Games untuk belajar sambil bermain. Pilih game kegemaran anda hari ini!",
            canonical: "https://www.flyhigh.my/gameshub",
          },
        },
        {
          path: "gameshub/roblox",
          name: "GamesHubRoblox",
          component: GamesHubRoblox,
          meta: {
            title: "Roblox Games — Bermain Sambil Belajar | FlyHigh Education Centre",
            description: "Koleksi Roblox Games pilihan FlyHigh Education Centre. Main game Roblox kegemaran anda sambil belajar!",
            canonical: "https://www.flyhigh.my/gameshub/roblox",
          },
        },
        {
          path: "gameshub/mental",
          name: "GamesHubMental",
          component: GamesHubMental,
          meta: {
            title: "Mental Games — Uji Minda Anda | FlyHigh Education Centre",
            description: "Koleksi Mental Games FlyHigh untuk menguji minda anda. Termasuk Word Search, Uji Minda quiz dan banyak lagi!",
            canonical: "https://www.flyhigh.my/gameshub/mental",
          },
        },
        {
          path: "gameshub/wordsearch",
          name: "WordSearch",
          component: WordSearch,
          meta: {
            title: "Word Search — Cari Perkataan Tersembunyi | FlyHigh Education Centre",
            description: "Game Word Search FlyHigh: cari perkataan tersembunyi dalam grid huruf. Latih minda dan perbendaharaan kata anda!",
            canonical: "https://www.flyhigh.my/gameshub/wordsearch",
          },
        },
        {
          path: "gameshub/wordscramble",
          name: "WordScramble",
          component: WordScramble,
          meta: {
            title: "Word Scramble — Susun Perkataan | FlyHigh Education Centre",
            description: "Game Word Scramble FlyHigh: susun huruf bercampur untuk membentuk perkataan. Latih minda, ejaan dan perbendaharaan kata anda!",
            canonical: "https://www.flyhigh.my/gameshub/wordscramble",
          },
        },
        {
          path: "gameshub/sudoku",
          name: "SudokuGame",
          component: Sudoku,
          meta: {
            title: "Sudoku — Teka-teki Nombor | FlyHigh Education Centre",
            description: "Main Sudoku FlyHigh: isi nombor 1-9 tanpa ulangan dalam baris, lajur dan petak 3×3. Asah logik dan strategi anda!",
            canonical: "https://www.flyhigh.my/gameshub/sudoku",
          },
        },
        {
          path: "QuizPKSKSet2",
          name: "QuizPKSKSet2",
          component: QuizPKSKSet2,
          meta: {
            title: "PKSK SET 2 — Pentaksiran Kemahiran & Sahsiah | FlyHigh Quiz",
            description: "Quiz PKSK SET 2 lengkap dengan 100 soalan merangkumi Kecerdasan Insaniah, Pengetahuan Am, Matematik, Sains, dan Bahasa Inggeris.",
            canonical: "https://www.flyhigh.my/QuizPKSKSet2",
          },
        },
        {
          path: "quiz/:setCode",
          name: "QuizPlay",
          component: QuizPlay,
          meta: {
            title: "Quiz | FlyHigh Education",
            requiresAuth: true,
          },
        },
        {
          path: "quiz-try/:setCode",
          name: "QuizTry",
          component: QuizTry,
          meta: {
            title: "Percubaan Percuma Quiz | FlyHigh Education",
          },
        },
        {
          path: "quiz-auth",
          name: "QuizAuth",
          component: QuizAuth,
          meta: {
            title: "Daftar / Log Masuk | FlyHigh Quiz",
          },
        },
        {
          path: "quiz-subscription",
          name: "QuizSubscription",
          component: QuizSubscription,
          meta: {
            title: "Pelan Langganan | FlyHigh Quiz",
          },
        },
        {
          path: "quiz-profile",
          name: "QuizProfile",
          component: () => import("@/views/QuizProfile.vue"),
          meta: {
            title: "Profil Pelajar | FlyHigh Quiz",
            requiresAuth: true,
          },
        },
        {
          path: "quiz-leaderboard",
          name: "QuizLeaderboard",
          component: () => import("@/views/QuizLeaderboard.vue"),
          meta: {
            title: "Kedudukan Quiz | FlyHigh Quiz",
          },
        },
        {
          path: "quiz-summary/:attemptId",
          name: "QuizSummary",
          component: () => import("@/views/QuizSummary.vue"),
          meta: {
            title: "Ringkasan Kuiz | FlyHigh Quiz",
            requiresAuth: true,
          },
        },
      ],
    },


  ];
}
